import {
	Component,
	OnInit,
	AfterViewInit,
	Input,
	OnChanges,
	ViewChild,
	ViewContainerRef,
	ElementRef,
} from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import Chart from 'chart.js/auto';
import { ChartJSWidgetComponent } from '../chart-js-widget.component';
import { v4 as uuidv4 } from 'uuid';

@Component({ 
	selector: 'app-chart-js-linechart',
	templateUrl: './chart-js-linechart.component.html',
	styleUrls: ['./chart-js-linechart.component.scss'],
})
export class ChartJSLineChartComponent extends ChartJSWidgetComponent implements OnInit, OnChanges, AfterViewInit 
{
	canvas: any;
	context: any;
	chartId : string = uuidv4().replaceAll("-", "");
	rect : { width : string; height : string } = { width : "100%", height : "100%" };

	@ViewChild('chartCanvas') chartCanvas:
		| ElementRef
		| null
		| undefined;

	chart: any;

	ngOnChanges() {}

	ngOnInit(): void {
		this.createChart();
	}

	ngAfterViewInit(): void {
		const element = document.querySelector("#" + this.chartId);
		if(element)
		{
			const parentRect = element?.parentElement?.parentElement?.getBoundingClientRect();
			if(parentRect)
			{
				this.rect = { width : parentRect?.width + "px", height : parentRect?.height + "px" };
			}
			
		}
		this.createChart();
	}

	createChart(): void {
		this.chart = new Chart("MyChart", {
			type: 'line', //this denotes tha type of chart

      data: {// values on X-Axis
        labels: ['2022-05-10', '2022-05-11', '2022-05-12','2022-05-13',
								 '2022-05-14', '2022-05-15', '2022-05-16','2022-05-17', ], 
	       datasets: [
          {
            label: "Sales",
            data: ['467','576', '572', '79', '92',
								 '574', '573', '576'],
            backgroundColor: 'blue'
          },
          {
            label: "Profit",
            data: ['542', '542', '536', '327', '17',
									 '0.00', '538', '541'],
            backgroundColor: 'limegreen'
          }  
        ]
      },
      options: {
        aspectRatio:2.5
      }
      
    });
	}
}
